<template>
  <div class="order-status-component">

    <div>
      <section class="vehicle-details" v-if="allocation">
        <div class="vehicle-details-content">
          <div class="container">
            <div class="row">
              <div class="col-sm-6">
                <h2>My Vehicle Details</h2>
                <h3 class="make"><span>{{ allocation.vehicle.manufacturerName }}</span> {{ allocation.vehicle.modelName }}</h3>
                <p class="model">{{ allocation.vehicle.derivativeName }}</p>
                <!--                        <p class="registration">Registration</p>-->

                <div>
                  <span class="key">
                      Reg:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.registrationNumber }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Allocation Date:
                  </span>
                  <span class="value">
                    <strong>{{ formattedDate(allocation.allocationDate) }}</strong>
                  </span>
                </div>

                <h4 class="mb-2 mt-3">Contract Details</h4>
                <div>
                  <span class="key">
                      Term:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.contract.contractTerm }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Mileage:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.contract.contractDistance }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Start Date:
                  </span>
                  <span class="value">
                    <strong>{{ formattedDate(allocation.contract.actualStartDate) }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Estimated End Date:
                  </span>
                  <span class="value">
                    <strong>{{ formattedDate(allocation.contract.estimatedEndDate) }}</strong>
                  </span>
                </div>


                <h4 class="mb-2 mt-3">Vehicle Details</h4>

                <div>
                  <span class="key">
                      Colour:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.exteriorColour }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Fuel Type:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.fuelTypeName }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      Transmission:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.transmissionTypeName }}</strong>
                  </span>
                </div>
                <div>
                  <span class="key">
                      P11d Value:
                  </span>
                  <span class="value">
                      <strong>£{{ allocation.vehicle.p11DValue.toLocaleString() }}</strong>
                  </span>
                </div>
                <div v-if="Number(allocation.vehicle.cO2)">
                  <span class="key">
                      C0<sup>2</sup>:
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.co2 || '0' }}</strong>
                  </span>
                </div>
                <div v-if="allocation.vehicle.engineBHP">
                  <span class="key">
                      Power (BHP):
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.engineBHP }}</strong>
                  </span>
                </div>
                <div v-if="allocation.vehicle.engineKW">
                  <span class="key">
                      Power (kW):
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.engineKW }}</strong>
                  </span>
                </div>
<!--                <div v-if="allocation.vehicle.evRangeMiles">
                  <span class="key">
                      EV Range (Miles):
                  </span>
                  <span class="value">
                    <strong>{{ allocation.vehicle.evRangeMiles }}</strong>
                  </span>
                </div>-->
                <div style="display:flex;">
                  <span class="key">
                      BiK History:
                  </span>
                  <span class="value">
                    <ul style="list-style:none;padding-left:10px;width:200px;">
                      <li v-for="bik in allocation.vehicle.bikHistory">
                        <span>{{ bik.taxYear }}</span>: <span><strong>{{ bik.bikTaxablePercent }}%</strong></span>
                      </li>
                    </ul>
                  </span>
                </div>

              </div>
              <div class="col-sm-6">
                <vehicle-image :derivative="allocation.derivative" :showMain="true"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VehicleImage from "@/components/vehicle-details/vehicle-image.vue";
import VehicleSpecification from "@/components/vehicle-details/vehicle-specification.vue";
import {EventBus} from "@/event-bus";
import {useRoute} from "vue-router";

export default {
  name: "my-vehicle.vue",
  components: {VehicleSpecification, VehicleImage},

  props: [
    'session',
  ],

  setup() {
    const route = useRoute()
    return {route}
  },

  async beforeMount(to, from, next) {
    this.vehicles = [];

    EventBus.$emit('fetchData', [
      'driverprofile',
      'drivergrades',
      'allocations',
    ]);
  },

  computed: {
    allocation() {
      const allocations = this?.session?.driverProfile?.allocations;

      if (allocations?.current && allocations?.current.length) {
        const a = allocations.current.find((a) => Number(a.contract.contractID) === Number(this.$route.params.contractId));
        console.log(a);
        return a;
      }

      return null;
    }
  },

  methods: {
    formattedDate(dateString) {
      if (!dateString) {
        return '';
      }

      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const date = new Date(dateString);
      return date.toLocaleDateString(undefined, options);
    }
  }
}
</script>

<style scoped>
  .vehicle-details {
    padding: 40px;
    border: 0;
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.016), 0 2.6px 2.6px rgba(0, 0, 0, 0.022), 0 5.3px 5.3px rgba(0, 0, 0, 0.028), 0 11px 11px rgba(0, 0, 0, 0.034), 0 30px 30px rgba(0, 0, 0, 0.05);
  }
</style>
